﻿import { useEffect } from 'react';

import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { GMetrixLoader } from 'components/GMetrixLoader/GMetrixLoader';
import { useGroupDetails } from 'pages/groups/context';
import { FormattedMessage, useIntl } from 'react-intl';
import { TransactionApi } from 'apis/TransactionApi';
import { useNotification } from 'app/notifications';
import { getFormattedDate } from 'utils';
import { useSuperState } from 'hooks';
import { useApp } from 'app';

import 'pages/groups/components/XedTab/styles/xed-tab.scss';

export const XedTab = props => {

    const [state, setState] = useSuperState({
        errorMessage: '',
        loading: false,
        transactionHasXEDEnabled: false,
        xEDExternalIdMessage: '',
        xedGroupManagementUrl: ''
    });

    const { userId } = useApp();
    const { pageContext, update } = useGroupDetails();
    const { catchWithToast } = useNotification();
    const { formatMessage } = useIntl();

    const saveXEDChanges = async () => {

        if (pageContext && pageContext.Data && pageContext.Data.transactionDetails) {

            await TransactionApi.SyncXEDGroup(pageContext.Data.transactionDetails.Id, -1, -1);
            let assignedContent = await TransactionApi.GetLimitedContentByTransactionId(
                pageContext.Data.transactionDetails.Id,
                pageContext.Data.groupDetails?.Partner?.Id
            ).catch(catchWithToast(formatMessage({ id: 'failed_to_load_assigned_content.3392953e', defaultMessage: 'Failed to load assigned content.' })));

            if (assignedContent && assignedContent.length > 0) {

                assignedContent = assignedContent.map(content => {

                    if (content.ExpirationDate && content.StartDate && content.ExpirationDateString) {

                        content.ExpirationDate = new Date(content.ExpirationDate);
                        content.ExpirationDateString = getFormattedDate(new Date(content.ExpirationDateString));
                        content.StartDate = new Date(content.StartDate);
                        content.StartDateString = getFormattedDate(new Date(content.StartDateString));

                    }
                    return content;

                });

                update({
                    content: assignedContent,
                    contentOriginal: assignedContent
                });

            }

        }

        return false;

    };

    const getXEDEditGroupUrl = async () => {

        if (
            pageContext &&
            pageContext.Data &&
            pageContext.Data.transactionDetails &&
            pageContext.Data.transactionDetails.HasXED === true &&
            pageContext.Data.transactionDetails.XEDExternalId.length > 0
        ) {

            setState({ loading: true });
            try {

                const resp = await TransactionApi.GetXEDEditGroupUrlByTransactionAndUserId(pageContext.Data.transactionDetails.Id, userId);
                if (resp.Done === true && resp.Message.length > 0) {

                    setState({ transactionHasXEDEnabled: true, xedGroupManagementUrl: resp.Message });

                } else {

                    setState({ errorMessage: resp.Message });

                }
                setState({ loading: false });

            } catch (err: any) {

                setState({ errorMessage: err.Message, loading: false });

            }

        }

    };

    const setTransactionXEDEnabled = async () => {

        if (
            pageContext &&
            pageContext.Data &&
            pageContext.Data.transactionDetails &&
            pageContext.Data.transactionDetails.XEDExternalId
        ) {

            setState({ transactionHasXEDEnabled: pageContext.Data.transactionDetails.XEDExternalId.length > 0 });

        } else {

            if (
                pageContext?.Data.transactionDetails &&
                pageContext.Data.transactionDetails.Id
            ) {

                const response = await TransactionApi.CreateXEDGroup(
                    pageContext.Data.transactionDetails.Id,
                    -1,
                    -1,
                    pageContext.Data.transactionDetails.CourseIds
                ).catch(reason => {

                    throw reason.Message;

                });
                if (!response.Done) {

                    setState({ xEDExternalIdMessage: response.Message });

                }

            }

        }

    };

    useEffect(() => {

        setTransactionXEDEnabled();

    }, [pageContext?.Data.transactionDetails]);

    useEffect(() => {

        if (state.transactionHasXEDEnabled === true && state.xedGroupManagementUrl.length === 0) {

            getXEDEditGroupUrl();

        }

    }, [state.transactionHasXEDEnabled]);

    return (
        <>
            {pageContext && (
                <>
                    {state.xEDExternalIdMessage.length > 0 && (
                        <div className="p-3 xed-tab__error-message">
                            <FormattedMessage defaultMessage="Error: Something went wrong in the XED process. You don't have an XEDExternalId which we need to proceed." id="error_something_went_wrong_in_the_xed_pr.b98d0848" />
                            :
                            {state.xEDExternalIdMessage}
                        </div>
                    )}

                    {state.errorMessage.length > 0 && (
                        <div className="p-3 xed-tab__error-message">

                            <FormattedMessage defaultMessage="GetXEDEditGroupUrlByTransactionAndUserId" id="getxededitgroupurlbytransactionanduserid.4961070d" />
                            {' '}
                            {state.errorMessage}
                        </div>
                    )}

                    {state.loading && state.errorMessage.length === 0 && (
                        <div className="text-center">
                            <GMetrixLoader />
                        </div>
                    )}

                    {!state.loading && state.errorMessage.length === 0 && state.transactionHasXEDEnabled && (
                        <div className="text-center">
                            <GMetrixButton hidden={true} onClick={saveXEDChanges}>
                                <FormattedMessage defaultMessage="Save XED Changes" id="save_xed_changes.49f3c56d" />
                            </GMetrixButton>
                            <iframe
                                height="100%"
                                id={'xed-frame-' + pageContext.Data.transactionDetails?.Id}
                                src={state.xedGroupManagementUrl}
                                style={{ minHeight: '600px' }}
                                width="100%"
                            ></iframe>
                        </div>
                    )}
                </>
            )}
        </>
    );

};
